import styled, { css } from 'styled-components'
import BaseButton from 'components/Button'

import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

export const Form = styled.div`
    margin: 30px;
    min-width: 500px;
    height: 100%;
`

export const FormContent = styled.div`
    display: flex;
    flex-direction: column;

    border: 1px solid #f0f0f0;
    border-radius: 16px;
`

export const FormHeader = styled.div`
    padding: 20px;
    border-bottom: 1px solid #f0f0f0;
    align-items: center;
    width: 100%;
    display: flex;
    justify-content: space-between;
`

export const FormTitle = styled.h3`
    max-width: 200px;
    font-weight: 600;
    font-size: 16px;
    line-height: 21px;
    color: ${(p) => p.$color};

    @media (max-width: 1200px) {
        max-width: 100%;
        padding-right: 10px;
    }
`

export const Label = styled.span`
    font-weight: 400;
    font-size: 12px;
    line-height: 13px;
    text-transform: none;
    text-align: center;

    ${(p) =>
        p.$pos &&
        css`
            grid-column: ${(p) => p.$pos};
        `};

    color: ${(p) => p.$color ?? colors.black};
`

export const FormFields = styled.div`
    display: flex;
    width: 100%;
    max-width: 230px;

    .card-quantity {
        flex: 0.9;
    }

    .card-value {
        flex: 1.1;
    }

    div + div {
        margin-left: 10px;
    }

    @media (max-width: 1200px) {
        max-width: 350px;
    }
`

export const FormColumn = styled.div`
    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 5px;
    }
`

export const FormProductRow = styled.div`
    display: grid;
    grid-template-columns: 40px 140px 112px 125px;
    column-gap: 15px;

    ${(p) =>
        p.theme.home &&
        css`
            @media (max-width: 1200px) {
                grid-template-columns: 40px 1fr 160px 180px;
            }

            @media (max-width: 1000px) {
                grid-template-columns: 40px 1fr 160px 180px;
            }
        `}

    ${mobile(`
        grid-template-columns: 40px 5fr 6fr;
        grid-template-rows: auto auto;
    `)}
`

export const FormRow = styled.div`
    display: flex;

    align-items: center;

    .card-quantity {
        flex: 0.9;
    }

    .card-value {
        flex: 1;
    }

    > * + * {
        margin-left: 10px;
    }
`

export const FormTitles = styled.div`
    display: grid;
    grid-template-columns: 40px 1fr 112px 125px;
    column-gap: 15px;

    @media (max-width: 1200px) {
        grid-template-columns: 40px 1fr 160px 180px;
    }
`

export const InputLabel = styled.label`
    font-size: 11px;
    color: ${(p) => p.labelColor ?? 'rgba(255, 255, 255, 0.8)'};
    line-height: 1.5;
    display: none;

    ${mobile(`
        display: block;
    `)}
`

export const Icon = styled.div`
    display: flex;
    align-items: center;

    img {
        width: 40px;
        height: 40px;
    }

    ${mobile(`
        display: block;
        grid-row: span 2;
    `)}
`

export const FormBody = styled.div`
    padding: 20px;

    display: flex;
    flex-direction: column;

    > * + * {
        margin-top: 10px;
    }
`

export const ErrorMessageContainer = styled.div`
    text-align: right;
`

export const Button = styled(BaseButton)`
    margin: 10px 0 0 !important;
    width: 100%;
`
